<div class="content-wrapper table-full-bx">
    <div class="page-content account-settings">
        <div class="row">
            <div class="col-lg-12">
                <div class="ibox ">
                    <div class="ibox-body">
                        <div class="iboxcontent">
                            <h3>Account Settings</h3>
                        </div>
                        <!-- Account settings  -->
                        <div class="row">
                            <div class="col-lg-3 col-sm-12">
                                <!-- Tabs nav -->
                                <div class="nav  nav-pills nav-pills-custom pills-custom">
                                    <a class="nav-link mb-3 p-3 " href="javascript:void(0);"
                                        routerLink="/account-settings/change-password">
                                        <span class=" ">Change password</span>
                                    </a>

                                    <a class="nav-link mb-3 p-3  " href="javascript:void(0);"
                                        routerLink="/account-settings/notification">

                                        <span class=" ">Notifications</span>
                                    </a>

                                    <a class="nav-link mb-3 p-3 " href="javascript:void(0);"
                                        routerLink="/account-settings/save-card" hidden>

                                        <span class=" ">Saved cards</span>
                                    </a>



                                    <a class="nav-link mb-3 p-3 " href="javascript:void(0);"
                                        routerLink="/account-settings/inventory-history">

                                        <span class="">Subscriptions</span>
                                    </a>
                                    <a class="nav-link mb-3 p-3 active " href="javascript:void(0);"
                                        routerLink="/account-settings/billing-address">

                                        <span class=" ">Billing address</span>
                                    </a>

                                    <a class="nav-link mb-3 p-3 " href="javascript:void(0);"
                                        routerLink="/account-settings/my-templates">

                                        <span class=" ">My templates</span>
                                    </a>

                                </div>
                            </div>
                            <div class="col-lg-6 col-sm-12 tabwidth marginstart">
                                <!-- Tabs content -->
                                <div class="tab-content" id="v-pills-tabContent">
                                    <div class="tab-pane fade  bg-box show active ">
                                        <form [formGroup]="form" (ngSubmit)="onSubmit()">
                                            <div class=" subHeader billing-address">
                                                <h2 class="mainTitle">Billing Address</h2>

                                                <div class=" d-flex justify-content-between">
                                                    <div class="form-group">
                                                        <label>First Name<span class="orange">*</span></label>
                                                        <input type="input" class="form-control" placeholder="Enter"
                                                            formControlName="firstName">
                                                        <div class="text-danger"
                                                            *ngIf="form.controls['firstName'].hasError('required') && showError">
                                                            *Please enter first name.
                                                        </div>
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Last Name<span class="orange">*</span></label>
                                                        <input type="input" class="form-control" placeholder="Enter"
                                                            formControlName="lastName">
                                                        <div class="text-danger"
                                                            *ngIf="form.controls['lastName'].hasError('required') && showError">
                                                            *Please enter last name.
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class=" d-flex justify-content-between">
                                                    <div class="form-group">
                                                        <label>Phone number<span class="orange">*</span></label>
                                                        <div class="countryCode">
                                                            <span><input type="text" class="form-control"
                                                                    formControlName="countryCode" readonly
                                                                    placeholder="(+1)" /></span>
                                                            <input type="text" class="form-control" placeholder="Enter "
                                                                formControlName="phoneNumber" appPhoneMask
                                                                id="phone-number" (keypress)="preventNumbers($event)"
                                                                maxlength="10">
                                                        </div>
                                                        <div class="text-danger"
                                                            *ngIf="form.controls['phoneNumber'].hasError('required') && showError">
                                                            *Please enter phone number.
                                                        </div>
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Company Name<span class="orange">*</span></label>
                                                        <input type="text" class="form-control"
                                                            placeholder=" Cr 92 No. 34E-112, Medellín"
                                                            formControlName="companyName" maxlength="100" />
                                                        <div class="text-danger"
                                                            *ngIf="form.controls['companyName'].hasError('required') && showError">
                                                            *Please enter company name.
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="form-group">
                                                    <label>Address<span class="orange">*</span></label>
                                                    <textarea type="text" class="form-control"
                                                        placeholder=" Cr 92 No. 34E-112, Medellín"
                                                        formControlName="address" maxlength="500"></textarea>
                                                    <div class="text-danger"
                                                        *ngIf="form.controls['address'].hasError('required') && showError">
                                                        *Please enter address.
                                                    </div>
                                                </div>
                                                <div class=" d-flex justify-content-between">
                                                    <div class="form-group">
                                                        <label>Zip Code<span class="orange">*</span></label>
                                                        <input type="text" class="form-control" placeholder="Enter"
                                                            formControlName="zipCode"
                                                            (keypress)="preventNumbers($event)" maxlength="6">
                                                        <div class="text-danger"
                                                            *ngIf="form.controls['zipCode'].hasError('required') && showError">
                                                            *Please enter zip code.
                                                        </div>
                                                    </div>
                                                    <div class="form-group">
                                                        <label>City<span class="orange">*</span></label>
                                                        <input type="text" class="form-control" placeholder="Enter "
                                                            formControlName="city">
                                                        <div class="text-danger"
                                                            *ngIf="form.controls['city'].hasError('required') && showError">
                                                            *Please enter city.
                                                        </div>

                                                    </div>
                                                </div>

                                                <!-- <div class=" d-flex justify-content-between"> -->
                                                <div class="form-group">
                                                    <label> Country<span class="orange">*</span></label>
                                                    <select class="form-control" formControlName="countryName">
                                                        <option disabled selected> Please select</option>
                                                        <option value="USA"> USA</option>
                                                    </select>
                                                    <div class="text-danger"
                                                        *ngIf="form.controls['countryName'].hasError('required') && showError">
                                                        *Please enter country.
                                                    </div>
                                                </div>

                                                <!-- </div> -->
                                                <div class="form-group mt-3">
                                                    <!-- <a href="javascript:void(0);" routerLink="settings" class="commonBtn mt-5"> Save Changes </a> -->
                                                    <input type="submit" value="Save" class="commonBtn width50 mt-3" />
                                                </div>

                                                <!-- end -->
                                            </div>
                                        </form>

                                    </div>
                                </div>

                            </div>

                        </div>
                        <!-- End -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>